import { Button } from "@/components/UI/Button";
import { User } from "@auth0/auth0-react";
import axios from "axios";
import { useState } from "react";
import { Tooltip } from "react-tooltip";
import appSettings from "../../../../appsettings.json";
import { cubeCustomColors } from "../../../../tailwind.config";
// WYWA: disabled for v1
// import useBlotterSnapshotStore from "@/store/notifications/blotterSnapshotStore";

export default function ProfileClient({
  theme,
  user,
  logout,
}: {
  theme: any;
  user: User | undefined;
  logout: any;
}) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipClick = () => {
    setIsTooltipOpen((prev) => !prev); // Toggle tooltip open/close
  };

  const logoutWithRedirect = () => {
    // WYWA: disabled for v1
    // useBlotterSnapshotStore.getState().saveSnapshot();
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const userFieldsToDisplayLeft = [
    { content: user?.name },
    { content: user?.email },
  ];

  // Kept in case Desk or Role are put back into the info.
  // let userFieldsToDisplayRight = [{ content: "Desk:" }, { content: "Role:" }];

  const [resetMessage, setResetMessage] = useState<string>("");

  const initiatePasswordReset = () => {
    if (user) {
      const options = {
        method: "POST",
        url: `https://${appSettings.Auth0.Domain}/dbconnections/change_password`,
        headers: { "content-type": "application/json" },
        data: {
          client_id: appSettings.Auth0.ClientId,
          //  client_id: "FmSPiybU6pZyhNJhj18LDadmVEQrhFuX",
          email: user.email,
          connection: "Username-Password-Authentication",
        },
      };

      axios
        .request(options)
        .then(function () {
          setResetMessage("Email sent to reset password.");
        })
        .catch(function () {
          setResetMessage("Too many requests.");
        });
    }

    setTimeout(() => {
      setResetMessage("");
    }, 3000);
  };

  return (
    user && (
      <div className="flex w-[35px] items-center justify-center overflow-hidden">
        <div
          className="w-8"
          id="profileIconContainer"
          onClick={handleTooltipClick}
        >
          <img
            data-tooltip-id={"profile"}
            src={user.picture}
            alt={user.name}
            className="cursor-pointer rounded-full"
          />
        </div>

        <Tooltip
          id={"profile"}
          place="bottom"
          variant="info"
          className="z-40 "
          opacity={0.95}
          clickable={true}
          openOnClick={true}
          isOpen={isTooltipOpen} // Controls tooltip visibility
          setIsOpen={setIsTooltipOpen} // Allows tooltip to manage its state
          globalCloseEvents={{ clickOutsideAnchor: true, escape: true }} // Enables closing on outside click and ESC
          border="1px solid gray"
          style={{
            backgroundColor:
              theme == "dark"
                ? cubeCustomColors.cubeBaseDark[700]
                : cubeCustomColors.cubeBase[700],
            transform: "translateY(-10px)",
          }}
        >
          <div className="flex min-h-[140px] w-[270px] flex-col">
            <div className="flex w-full justify-between">
              <div className="flex flex-col justify-center">
                {userFieldsToDisplayLeft.map((field, index) => (
                  <div
                    key={index}
                    className="hidden px-3 text-black dark:text-white  sm:block"
                  >
                    {field.content}
                  </div>
                ))}
              </div>
              <div className="mr-2 flex w-14 flex-col pt-2">
                <img
                  data-tooltip-id={"profile"}
                  src={user.picture}
                  alt={user.name}
                  className="cursor-pointer rounded-full"
                />
              </div>
            </div>

            <div className="flex h-10 w-full flex-row justify-around pt-2 text-black dark:text-white">
              <Button
                variant={"mainOrangeAction"}
                size={"button_md"}
                onClick={() => initiatePasswordReset()}
              >
                Reset Password
              </Button>
              <Button
                onClick={() => logoutWithRedirect()}
                size={"button_md"}
                className={
                  "hover-text-white block rounded border border-black bg-cubeBase-800 text-black hover:bg-orange-600 dark:border-white dark:bg-cubeBaseDark-800 dark:text-white dark:hover:bg-orange-600"
                }
                id="logoutButton"
              >
                Logout
              </Button>
            </div>
            <div className=" w-full justify-center px-0 text-center italic text-black dark:text-white">
              {resetMessage}
            </div>
          </div>
        </Tooltip>
      </div>
    )
  );
}
